import { Navigate, RouteObject, useLocation } from 'react-router-dom';

import { TEST_LOGS_PATH } from '../constants';

// The log moved to the Integrations page. Keep the old address working, with its query (?channel=whatsapp&filter=read).
const ToTestLogs = () => {
  const { search } = useLocation();
  return <Navigate to={`${TEST_LOGS_PATH}${search}`} replace />;
};

const FakeProviderLogsRoute: RouteObject = {
  path: '/fake-provider-logs',
  element: <ToTestLogs />,
};

export default FakeProviderLogsRoute;
